import React from "react";
import "../styles/landing.css";
import Footer from "../components/Footer";
import jobPinglogo from "../assets/jobPinglogo.png";

const LandingPage = () => {
  return (
    <div className="landing-wrapper">
      {/* Section 1 */}
      <section className="section section-hero">
        <img src={jobPinglogo} alt="jobPinglogo" className="landing-logo" />

        <h1 className="title-glow">Welcome to JobPing</h1>
        <marquee className="marquee-text">
          🚧 This website is currently under development 🚧
        </marquee>
      </section>

      {/* Section 2 */}
      <section className="section section-problem">
        <h2 className="animated-heading">
          Applied on Naukri, LinkedIn, Indeed?
        </h2>
        <p className="animated-subtext">
          But no one responds? We get it. That's frustrating.
        </p>
      </section>

      {/* Section 3 */}
      <section className="section section-promise improved-promise">
        <div className="promise-content-wrapper">
          <h2 className="highlight-text glow-heading">
            📞 Get Responses That Matter
          </h2>
          <p className="promise-description fade-in">
            Apply to <strong>10 companies</strong>, and we’ll ensure you hear
            back from at least <strong>5</strong>.
          </p>
          <h2 className="cta-text pulse-text"> Start Your Journey Now</h2>
          <button
            className="cta-button fancy-button"
            onClick={() => (window.location.href = "/home")}
          >
            APPLY FOR JOBS
          </button>
        </div>

        <Footer />
      </section>
    </div>
  );
};

export default LandingPage;
